import React from "react";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import {safeHTML} from "../../utils/safeHTML";
import styles from "./Games.module.scss";
import classNames from "classnames";

const GamesItem = React.forwardRef(
  function GamesItem(props, ref) {
    const {title, image, link, cost, index, isFetchpriorityGame} = props;
    const isFetchpriority = index < 3 && isFetchpriorityGame;
    return (
      <a href={link}
         ref={ref}
         target={"_blank"}
         className={styles.games__item}>
                      <span className={styles.games__itemIcon}>
                        <img src={image} alt="name"
                             fetchpriority={isFetchpriority ? "high" : "auto"}
                             loading={isFetchpriority ? "eager" : "lazy"}
                        />
                      </span>
        <span className={styles.games__itemPrice}>{safeHTML(cost)}₽</span>
        <Button className={classNames(buttonStyles.button_white, buttonStyles.button_mini, styles.games__itemButton)}
                tag={"span"}>{`Купить`}</Button>
      </a>
    );
  });
export default GamesItem;
GamesItem.propTypes = {};

